import { Box, Typography } from '@glplus/glpweb-dsl';

export const BORDER = '#DDE4E0';
export const MUTED = '#5B6573';

export function money(cents: number | null | undefined): string {
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format((cents ?? 0) / 100);
}

export function dateTime(value: string | null | undefined): string {
  if (!value) return '—';
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
}

export function evidenceEntries(...sources: unknown[]): unknown[] {
  return sources.flatMap((source) => Array.isArray(source) ? source : []);
}

export function EvidenceList({ evidence }: { evidence: unknown }) {
  if (!Array.isArray(evidence) || evidence.length === 0) return <Typography sx={{ color: MUTED }}>No structured evidence was attached.</Typography>;
  return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    {evidence.map((entry, index) => {
      const item: Record<string, unknown> = entry && typeof entry === 'object'
        ? entry as Record<string, unknown>
        : { value: entry };
      const url = typeof item.reviewUrl === 'string'
        ? item.reviewUrl
        : typeof item.url === 'string'
          ? item.url
          : typeof item.sourceUrl === 'string'
            ? item.sourceUrl
            : null;
      const kind = typeof item.type === 'string' ? item.type : typeof item.evidenceType === 'string' ? item.evidenceType : null;
      const title = typeof item.fileName === 'string' ? item.fileName : kind ? kind.replaceAll('_', ' ') : `Evidence ${index + 1}`;
      return <Box key={`${title}-${index}`} sx={{ border: `1px solid ${BORDER}`, borderRadius: '8px', p: 1.5, bgcolor: '#fff' }}>
        <Typography sx={{ fontWeight: 700, textTransform: 'capitalize' }}>{title}</Typography>
        {typeof item.contentType === 'string' && <Typography variant="caption" sx={{ color: MUTED }}>{item.contentType}</Typography>}
        {url && <Box component="a" href={url} target="_blank" rel="noopener noreferrer" sx={{ display: 'block', mt: 0.75, color: '#7A3E00', fontWeight: 700 }}>Open private evidence</Box>}
      </Box>;
    })}
  </Box>;
}
